const EMPTY_DOJO_FEED = { users: [], activities: [], coachComments: [] };

export const mergeDojoMembershipContext = (current = {}, dojo = null) => {
  const dojoId = dojo?._id ? String(dojo._id) : '';
  const sameDojo = dojoId && String(current.dojoId || '') === dojoId;
  return {
    ...(sameDojo ? current : EMPTY_DOJO_FEED),
    dojoName: dojo?.name || '',
    dojoId,
    inDojo: Boolean(dojo),
  };
};

export const mergeDojoFeedHydration = (feed, membershipContext, membershipAuthoritative) => {
  if (!membershipAuthoritative) return feed;

  const sameMembership = String(feed?.dojoId || '') === String(membershipContext.dojoId || '')
    && Boolean(feed?.inDojo) === Boolean(membershipContext.inDojo);
  const socialData = sameMembership ? feed : { users: [], activities: [], coachComments: [] };
  return {
    ...socialData,
    dojoName: membershipContext.dojoName,
    dojoId: membershipContext.dojoId,
    inDojo: membershipContext.inDojo,
  };
};

export const loadDojoFeedProgressively = (
  backendService,
  { includeMembership = true, includeFeed = true } = {},
) => {
  const membership = includeMembership && typeof backendService?.getMyDojo === 'function'
    ? backendService.getMyDojo()
    : Promise.resolve(undefined);
  const feed = includeFeed
    ? backendService.getSocialActivityFeed('dojo', null, null, null, 100)
    : Promise.resolve(null);

  return { membership, feed };
};
